
export const HabitFrequencyEnum = {
  ONCE_W : "once_w",
  TWICE_W : "twice_w",
  THRICE_W : "thrice_w",
  FOUR_W : "four_w",
  FIVE_W : "five_w",
  SIX_W : "six_w",

  OCCASIONAL: "occasional",
  WEEKLY: "weekly",
  DAILY: "daily",
  MONTHLY: "monthly",
  ONCE: "once",
  RARELY: "rarely",
  NEVER: "never",
};

